import { PaymentConfigAllowPatientSubmit } from '../../models/paymentConfig';
import client from '../httpclient';

const getPaymentSubcategories = (
  protocolId: string,
): Promise<PaymentConfigAllowPatientSubmit> => client.get(
  `/re/v1/protocol/${protocolId}/allowPatientSubmitRequest`,
);

export default getPaymentSubcategories;
